module.exports = __webpack_public_path__ + "img/smart.b1c4f5b6.png";